import GovtIdProviderGuard from './GovtIdProviderGuard';

export default GovtIdProviderGuard;
